export const tournaments = [
  {
    id: 1,
    title: '2026 LPL 夏季总决赛',
    game: '英雄联盟',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20esports%20arena%20grand%20final%20stage%20with%20dramatic%20lighting%20and%20huge%20crowd%2C%20professional%20esports%20photography%2C%20epic%20atmosphere%2C%20dark%20background%20with%20colorful%20spotlights&width=800&height=450&seq=tournament-lol-01&orientation=landscape',
    date: '2026.08.15',
    status: 'upcoming',
    prize: '¥5,000,000',
    teams: ['BLG', 'JDG'],
    viewers: '2.3M',
    slug: 'lpl-summer-2026-final',
  },
  {
    id: 2,
    title: 'CS2 IEM 科隆站 2026',
    game: 'CS2',
    image: 'https://readdy.ai/api/search-image?query=Counter%20Strike%202%20esports%20tournament%20stage%20with%20players%20on%20computers%2C%20arena%20filled%20with%20fans%2C%20professional%20gaming%20event%20photography%2C%20dramatic%20stage%20lighting&width=800&height=450&seq=tournament-cs2-01&orientation=landscape',
    date: '2026.08.20',
    status: 'upcoming',
    prize: '$1,000,000',
    teams: ['FaZe', 'G2', 'NAVI', 'Vitality'],
    viewers: '1.8M',
    slug: 'iem-cologne-2026',
  },
  {
    id: 3,
    title: 'DOTA2 国际邀请赛 TI13',
    game: 'DOTA2',
    image: 'https://readdy.ai/api/search-image?query=DOTA%202%20The%20International%20esports%20championship%20stage%20with%20golden%20aegis%20trophy%2C%20packed%20stadium%20with%20passionate%20fans%2C%20epic%20gaming%20event%20atmosphere&width=800&height=450&seq=tournament-dota-01&orientation=landscape',
    date: '2026.09.05',
    status: 'upcoming',
    prize: '$3,000,000',
    teams: ['Team Spirit', 'LGD', 'OG', 'Tundra'],
    viewers: '3.5M',
    slug: 'ti13-2026',
  },
  {
    id: 4,
    title: 'Valorant 冠军巡回赛 2026',
    game: 'Valorant',
    image: 'https://readdy.ai/api/search-image?query=Valorant%20esports%20championship%20tour%20stage%20with%20teams%20competing%2C%20futuristic%20arena%20design%2C%20neon%20lighting%2C%20professional%20gaming%20event%20crowd&width=800&height=450&seq=tournament-val-01&orientation=landscape',
    date: '2026.08.22',
    status: 'live',
    prize: '$500,000',
    teams: ['Sentinels', 'LOUD', 'PRX', 'FNATIC'],
    viewers: '1.2M',
    slug: 'valorant-champions-2026',
  },
  {
    id: 5,
    title: '王者荣耀 KPL 秋季赛',
    game: '王者荣耀',
    image: 'https://readdy.ai/api/search-image?query=Honor%20of%20Kings%20KPL%20esports%20arena%20with%20mobile%20gaming%20stage%2C%20Chinese%20esports%20event%20with%20spectacular%20visuals%2C%20large%20crowd%20cheering&width=800&height=450&seq=tournament-kpl-01&orientation=landscape',
    date: '2026.08.10',
    status: 'live',
    prize: '¥8,000,000',
    teams: ['AG超玩会', 'eStar', 'Hero', 'WB'],
    viewers: '4.5M',
    slug: 'kpl-autumn-2026',
  },
  {
    id: 6,
    title: 'PUBG 全球锦标赛 PGC 2026',
    game: 'PUBG',
    image: 'https://readdy.ai/api/search-image?query=PUBG%20global%20championship%20esports%20battle%20royale%20stage%20with%20teams%20at%20computers%2C%20massive%20screen%20displaying%20game%2C%20professional%20gaming%20event&width=800&height=450&seq=tournament-pubg-01&orientation=landscape',
    date: '2026.09.15',
    status: 'upcoming',
    prize: '$2,000,000',
    teams: ['17Gaming', 'Gen.G', 'SQ', 'TWIS'],
    viewers: '2.0M',
    slug: 'pgc-2026',
  },
];

export const newsArticles = [
  {
    id: 1,
    title: 'LPL夏季赛决赛前瞻：BLG与JDG的巅峰对决',
    excerpt: '经过数月的激烈角逐，BLG和JDG两支顶级战队终于将在夏季赛总决赛中相遇。本文详细分析两队近期状态与战术风格。',
    image: 'https://readdy.ai/api/search-image?query=professional%20League%20of%20Legends%20esports%20match%20with%20two%20teams%20facing%20off%20on%20stage%2C%20dramatic%20lighting%2C%20Chinese%20esports%20arena%20atmosphere%2C%20editorial%20sports%20photography&width=800&height=500&seq=news-lpl-01&orientation=landscape',
    date: '2026.08.08',
    category: '赛事前瞻',
    game: '英雄联盟',
    views: 12500,
    slug: 'lpl-summer-final-preview',
  },
  {
    id: 2,
    title: 'CS2新赛季排名更新：FaZe重回世界第一',
    excerpt: 'HLTV最新世界排名出炉，FaZe Clan凭借近期连续夺冠的强势表现，成功超越NAVI登顶世界第一。',
    image: 'https://readdy.ai/api/search-image?query=Counter%20Strike%202%20esports%20team%20celebrating%20championship%20victory%20on%20stage%20with%20trophy%2C%20confetti%20and%20spotlights%2C%20professional%20esports%20photography&width=800&height=500&seq=news-cs2-01&orientation=landscape',
    date: '2026.08.07',
    category: '排名更新',
    game: 'CS2',
    views: 8900,
    slug: 'cs2-ranking-update-faze',
  },
  {
    id: 3,
    title: 'DOTA2 TI13直邀名单确认，中国战队LGD成功入围',
    excerpt: 'V社正式公布了TI13的直邀名单，LGD作为中国赛区代表成功获得直接晋级资格，将在西雅图争夺冠军。',
    image: 'https://readdy.ai/api/search-image?query=DOTA%202%20esports%20team%20LGD%20on%20stage%20with%20fans%20waving%20flags%2C%20international%20tournament%20atmosphere%2C%20Chinese%20esports%20pride&width=800&height=500&seq=news-dota-01&orientation=landscape',
    date: '2026.08.06',
    category: '赛事新闻',
    game: 'DOTA2',
    views: 15600,
    slug: 'ti13-direct-invite-lgd',
  },
  {
    id: 4,
    title: 'Valorant新特工正式上线，职业赛场Meta即将大变',
    excerpt: '拳头游戏发布了Valorant最新特工，其独特技能组合预计将对职业赛场的战术体系产生深远影响。',
    image: 'https://readdy.ai/api/search-image?query=Valorant%20new%20agent%20reveal%20cinematic%20style%20image%20with%20futuristic%20character%20design%2C%20neon%20colors%2C%20dynamic%20action%20pose&width=800&height=500&seq=news-val-01&orientation=landscape',
    date: '2026.08.05',
    category: '游戏更新',
    game: 'Valorant',
    views: 7200,
    slug: 'valorant-new-agent-meta',
  },
  {
    id: 5,
    title: '王者荣耀世冠赛制改革：双败淘汰制正式引入',
    excerpt: 'KPL官方宣布2026年王者荣耀世界冠军杯将采用全新的双败淘汰赛制，为赛事增加更多悬念和观赏性。',
    image: 'https://readdy.ai/api/search-image?query=Honor%20of%20Kings%20esports%20press%20conference%20announcement%20with%20official%20representatives%2C%20Chinese%20esports%20event%20stage%2C%20professional%20photography&width=800&height=500&seq=news-kpl-01&orientation=landscape',
    date: '2026.08.04',
    category: '赛事改革',
    game: '王者荣耀',
    views: 18900,
    slug: 'kpl-world-championship-format-change',
  },
  {
    id: 6,
    title: 'PUBG电竞生态持续扩张，全球合作伙伴计划公布',
    excerpt: 'Krafton公布了2026年PUBG电竞全球合作伙伴名单，包括来自全球各大赛区的12支顶级战队。',
    image: 'https://readdy.ai/api/search-image?query=PUBG%20esports%20global%20partnership%20announcement%20event%20with%20team%20logos%20displayed%20on%20large%20screen%2C%20professional%20gaming%20conference&width=800&height=500&seq=news-pubg-01&orientation=landscape',
    date: '2026.08.03',
    category: '行业动态',
    game: 'PUBG',
    views: 6300,
    slug: 'pubg-global-partner-program',
  },
];

export const platformStats = [
  { label: '覆盖赛事', value: '200+', suffix: '场/年', icon: 'ri-trophy-line' },
  { label: '注册用户', value: '500万+', suffix: '', icon: 'ri-user-star-line' },
  { label: '合作战队', value: '80+', suffix: '支', icon: 'ri-team-line' },
  { label: '赛事数据', value: '99.9%', suffix: '准确率', icon: 'ri-dashboard-line' },
];

export const partners = [
  {
    name: '英特尔',
    logo: 'https://readdy.ai/api/search-image?query=Intel%20corporate%20logo%20on%20clean%20white%20background%2C%20minimal%20tech%20brand%20logo%20style&width=200&height=80&seq=partner-intel-01&orientation=landscape',
  },
  {
    name: '红牛',
    logo: 'https://readdy.ai/api/search-image?query=Red%20Bull%20energy%20drink%20corporate%20logo%20on%20clean%20white%20background%2C%20minimal%20brand%20logo&width=200&height=80&seq=partner-redbull-01&orientation=landscape',
  },
  {
    name: '罗技',
    logo: 'https://readdy.ai/api/search-image?query=Logitech%20gaming%20brand%20logo%20on%20clean%20white%20background%2C%20minimal%20tech%20peripheral%20brand%20logo&width=200&height=80&seq=partner-logitech-01&orientation=landscape',
  },
  {
    name: '雷蛇',
    logo: 'https://readdy.ai/api/search-image?query=Razer%20gaming%20brand%20logo%20on%20clean%20white%20background%2C%20minimal%20gaming%20gear%20brand%20logo&width=200&height=80&seq=partner-razer-01&orientation=landscape',
  },
  {
    name: 'Twitch',
    logo: 'https://readdy.ai/api/search-image?query=Twitch%20streaming%20platform%20brand%20logo%20on%20clean%20white%20background%2C%20minimal%20purple%20logo&width=200&height=80&seq=partner-twitch-01&orientation=landscape',
  },
  {
    name: '斗鱼',
    logo: 'https://readdy.ai/api/search-image?query=Douyu%20Chinese%20streaming%20platform%20brand%20logo%20on%20clean%20white%20background%2C%20minimal%20logo%20design&width=200&height=80&seq=partner-douyu-01&orientation=landscape',
  },
];

export const heroSlides = [
  {
    title: '开云电竞',
    subtitle: '专业电竞平台 · 点燃你的竞技激情',
    description: '汇聚全球顶级电竞赛事，提供专业数据分析与实时资讯，与百万电竞爱好者共同见证每一刻精彩',
    image: 'https://readdy.ai/api/search-image?query=epic%20esports%20arena%20with%20massive%20LED%20screens%20displaying%20game%20action%2C%20packed%20crowd%20cheering%2C%20dramatic%20stage%20lighting%20with%20golden%20and%20red%20tones%2C%20professional%20esports%20photography%2C%20cinematic%20wide%20shot&width=1920&height=900&seq=hero-esports-01&orientation=landscape',
    cta: '立即加入',
    ctaLink: '/about',
  },
];